import React from 'react';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { InputText } from '@msc-b2c/shared-components';
import { RootState, validateFormField } from '@msc-b2c/shared-utils';
import { Type } from '@msc-b2c/interfaces';
import styles from './carparkinginput.module.scss';

type CarParkingInputProps = Type.CarParkingInputProps;

function CarParkingInput({
  carParkingModelValue,
  setCarParkingModel,
  carParkingPlate,
  setCarParkingPlate,
}: Readonly<CarParkingInputProps>): React.ReactElement | null {
  const {
    register,
    clearErrors,
    formState: { errors },
    trigger,
  } = useForm<{ carParkingModel: string; carParkingPlate: string }>({
    shouldFocusError: false,
    defaultValues: {
      carParkingModel: carParkingModelValue,
      carParkingPlate,
    },
  });

  const drawerAEMConfig = useSelector((state: RootState) => state.myAreaCommonConfig.drawerProps);

  const isLayerExcursionOpen = useSelector(
    (state: RootState) => state.myAreaDrawers.isLayerMyAreaExcursionOpen
  );
  const myAreaOBSCardData = useSelector(
    (state: RootState) => state.myAreaDrawers.selectedMyAreaOBSCard
  );

  if (isLayerExcursionOpen || myAreaOBSCardData?.type?.code !== 'PARK') {
    return null;
  }

  return (
    <div className={styles['carpark-container']}>
      <InputText
        index={1}
        register={register}
        handleInputChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setCarParkingModel(e.target.value ?? '');
          if (e.target.value?.trim()) {
            clearErrors('carParkingModel');
          }
        }}
        errors={errors}
        name="carParkingModel"
        label={drawerAEMConfig.carModelLabelPlaceholder}
        placeholder={drawerAEMConfig.carModelLabelPlaceholder}
        clearErrors={clearErrors}
        styleOptions="inputText"
        validation={{
          validate: (value) =>
            validateFormField(value, drawerAEMConfig.validationRulesCarModelPlateContainer || []),
          onBlur: () => {
            trigger('carParkingModel');
          },
        }}
      />
      <InputText
        index={1}
        register={register}
        errors={errors}
        clearErrors={clearErrors}
        name="carParkingPlate"
        label={drawerAEMConfig.carPlateLabelPlaceholder}
        placeholder={drawerAEMConfig.carPlateLabelPlaceholder}
        styleOptions="inputText"
        handleInputChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setCarParkingPlate(e.target.value ?? '');
          if (e.target.value?.trim()) {
            clearErrors('carParkingPlate');
          }
        }}
        validation={{
          validate: (value) =>
            validateFormField(value, drawerAEMConfig.validationRulesCarModelPlateContainer || []),
          onBlur: () => {
            trigger('carParkingPlate');
          },
        }}
      />
    </div>
  );
}

export default CarParkingInput;
